export const CLASSIFICATION_OPTIONS = [
  { value: "is_guvenligi_ergonomi", label: "İş güvenliği veya ergonomi" },
  { value: "kalite", label: "Kalite" },
  { value: "maliyet", label: "Maliyet düşürme" },
  { value: "verimlilik_zaman", label: "İşi kolaylaştırma veya hızlandırma" },
  { value: "cevre", label: "Çevre" },
  { value: "diger", label: "Diğer" },
];

export const CLASSIFICATION_LABELS = Object.fromEntries(
  CLASSIFICATION_OPTIONS.map((item) => [item.value, item.label])
);

export const IMPACT_FREQUENCY_OPTIONS = [
  { value: "", label: "Seçiniz" },
  { value: "parca_basi", label: "Parça başı" },
  { value: "senelik", label: "Senelik" },
  { value: "bir_sefer", label: "Bir sefer" },
];

export const IMPACT_FREQUENCY_LABELS = Object.fromEntries(
  IMPACT_FREQUENCY_OPTIONS.filter((item) => item.value).map((item) => [item.value, item.label])
);

export const DEPARTMENT_SUGGESTIONS = [
  "Üretim",
  "Kalite",
  "Bakım",
  "Sevkiyat",
  "Depo",
  "Planlama",
  "İdari İşler",
  "Satın Alma",
  "Satış",
  "İnsan Kaynakları",
  "Muhasebe",
  "Dış Ticaret",
  "Diğer",
];
